import { motion } from "framer-motion";
import { cn } from "../../cn";

export default function GradientText({
  className,
  children,
  style,
}: {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <motion.span
      className={cn(
        "bg-clip-text text-transparent whitespace-nowrap",
        className,
      )}
      initial={{ backgroundPosition: "0 0" }}
      animate={{ backgroundPositionX: ["0px", "600px"] }}
      transition={{
        duration: 6,
        ease: "linear",
        repeat: Infinity,
        repeatType: "loop",
      }}
      style={{
        backgroundImage: `linear-gradient(to right, #FF8762, #FFCC63, #FF7CBB, #FFCC63, #FF8762)`,
        backgroundSize: "600px 100%",
        ...style,
      }}
    >
      {children}
    </motion.span>
  );
}
